/**
 * ACP tool-call updates may include `content` items of type `diff` with path + oldText/newText.
 * Cursor sometimes uses alternate keys or nests blocks; we recurse into common keys.
 *
 * @see https://agentclientprotocol.com/protocol/tool-calls
 */

import type { FileDiffRecord } from './push-diff.js';
import { walkValue } from './walk-update-for-diffs.js';

/**
 * Extract file diff records from a `session/update` payload (the `update` object).
 */
export function extractAcpFileDiffsFromUpdate(update: unknown, sessionParentPath: string): FileDiffRecord[] {
  if (!update || typeof update !== 'object') return [];
  const u = update as Record<string, unknown>;
  const out: FileDiffRecord[] = [];

  const content = u.content;
  if (Array.isArray(content)) {
    for (const x of content) walkValue(x, sessionParentPath, 0, out);
  }

  const byPath = new Map<string, FileDiffRecord>();
  for (const d of out) byPath.set(d.path, d);
  return [...byPath.values()];
}
